<div class="delete-modal" (click)="$event.stopPropagation()">
  <!-- Top decorative accent line -->
  <div class="delete-modal__accent-bar"></div>

  <!-- Header with alert icon and close button -->
  <div class="delete-modal__header">
    <div class="delete-modal__icon-wrapper">
      <div class="delete-modal__icon-ring"></div>
      <mat-icon class="delete-modal__icon">delete_forever</mat-icon>
    </div>
    <button type="button" class="delete-modal__close-btn" (click)="onCancel()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body Content -->
  <div class="delete-modal__body">
    <h2 class="delete-modal__title">{{ data.title || 'Confirm Deletion' }}</h2>
    <p class="delete-modal__message">{{ data.message }}</p>

    <!-- Vessel Details Card if provided -->
    <div class="delete-modal__meta-card" *ngIf="displayVesselName || data.vesselImo || displayPortName || data.dates">
      <div class="meta-card__row" *ngIf="displayVesselName">
        <span class="meta-card__label">
          <mat-icon class="meta-card__icon">directions_boat</mat-icon>
          Vessel:
        </span>
        <span class="meta-card__value bold">{{ displayVesselName }}</span>
      </div>

      <div class="meta-card__row" *ngIf="data.vesselImo">
        <span class="meta-card__label">
          <mat-icon class="meta-card__icon">tag</mat-icon>
          IMO:
        </span>
        <span class="meta-card__value">{{ data.vesselImo }}</span>
      </div>

      <div class="meta-card__row" *ngIf="displayPortName">
        <span class="meta-card__label">
          <mat-icon class="meta-card__icon">place</mat-icon>
          Port:
        </span>
        <span class="meta-card__value">{{ displayPortName | titlecase }}</span>
      </div>

      <div class="meta-card__row" *ngIf="data.dates">
        <span class="meta-card__label">
          <mat-icon class="meta-card__icon">calendar_today</mat-icon>
          Date:
        </span>
        <span class="meta-card__value">{{ data.dates }}</span>
      </div>
    </div>

    <p class="delete-modal__submessage" *ngIf="data.subMessage">
      <mat-icon class="submessage-icon">info_outline</mat-icon>
      <span>{{ data.subMessage }}</span>
    </p>
  </div>

  <!-- Footer Actions -->
  <div class="delete-modal__footer">
    <button type="button" class="delete-modal__btn delete-modal__btn--cancel" (click)="onCancel()"
      [disabled]="isDeleting">
      {{ data.cancelText || 'Cancel' }}
    </button>

    <button type="button" class="delete-modal__btn delete-modal__btn--confirm" (click)="onConfirm()"
      [disabled]="isDeleting">
      <mat-icon class="btn-icon">delete_outline</mat-icon>
      <span>{{ data.confirmText || 'Delete' }}</span>
    </button>
  </div>
</div>